export enum RefundType {
  Refund = "REFUND",
  Credit = "CREDIT",
  Partial = "PARTIAL",
}
